import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import client from '../../lib/apolloClient';
import theme from '../../lib/findBobMuiTheme';
import configureStore from '../../store/findBobPublicStore';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';
import SuccessionListSearch from '../../components/Succession/Search/SuccessionListSearch';

// Configure JSS
const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point'),
});

// Create a new class name generator
const generateClassName = createGenerateClassName();

const SuccessionListSearchContainer = (props, railsContext) => {
  const store = configureStore(props);
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  window.country = (railsContext && railsContext.country) || window.country || 'ca';
  const locale = window.locale;

  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        <Provider store={store}>
          <ApolloProvider client={client}>
            <JssProvider jss={jss} generateClassName={generateClassName}>
              <ThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3}>
                  <CssBaseline />
                  <SuccessionListSearch {...props} />
                </SnackbarProvider>
              </ThemeProvider>
            </JssProvider>
          </ApolloProvider>
        </Provider>
      </IntlProvider>
    </CurrencyProvider>
  );
};

export default SuccessionListSearchContainer; 